module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-144x144-a222370e621207eb4ffb4aec5491e33a.png";